export default class Entity{
    constructor({engine,type}){
        this.type = type || "default";
        this.zindex = 0;
        this.engine = engine;
        this.engine.entities.push(this);
    }

    update(){}

    render(ctx){}
}